(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wallet-bundle-design"] && !Shopify.designMode) return;
  try {
    function initWalletBundleDesign(scope=document){
  scope.querySelectorAll('[data-wallet-offer]').forEach(root=>{
    if(root.dataset.bundleDesignReady)return;
    const copy=root.querySelector('[data-wallet-bundle-copy]');
    if(!copy)return;
    root.dataset.bundleDesignReady='true';
    const packs=new Map(Array.from(copy.content.querySelectorAll('[data-offer-id]'),item=>[item.dataset.offerId,item.dataset]));
    const colorPrefix=copy.content.querySelector('[data-color-prefix]')?.dataset.colorPrefix||'';
    let scheduled=false;
    function setText(parent,className,text,prepend=false){
      let node=parent.querySelector('.'+className);
      if(!node){node=document.createElement('p');node.className=className;if(prepend)parent.prepend(node);else parent.append(node);}
      if(node.textContent!==text)node.textContent=text;
    }
    function update(){
      scheduled=false;
      root.querySelectorAll('.moonbundle-box').forEach(box=>{
        box.dataset.walletBundleDesign='true';
        box.querySelectorAll('.moonbundle-option-wrapper[data-offer-id]').forEach(wrapper=>{
          const pack=packs.get(wrapper.dataset.offerId);
          if(!pack)return;
          const details=wrapper.querySelector('.moonbundle-option-details');
          const column=details?.querySelector('.moonbundle-option-col');
          if(!column)return;
          setText(column,'wallet-bundle-kicker',pack.kicker,true);
          let title=column.querySelector('.wallet-bundle-title');
          if(!title){title=document.createElement('strong');title.className='wallet-bundle-title';column.insertBefore(title,column.querySelector('.moonbundle-option-col-inner'));}
          if(title.textContent!==pack.title)title.textContent=pack.title;
          setText(column,'wallet-bundle-included',pack.included);
          const checkbox=details.querySelector('.moonbundle-option-checkbox');
          const nativePreview=wrapper.querySelector('.moonbundle-offer-img-multi-product');
          if(checkbox&&!checkbox.querySelector('.moonbundle-offer-img')&&nativePreview){
            let preview=checkbox.querySelector('.wallet-bundle-preview');
            if(!preview){preview=document.createElement('img');preview.className='wallet-bundle-preview';preview.alt='';preview.width=50;preview.height=58;preview.loading='lazy';checkbox.append(preview);}
            if(preview.getAttribute('src')!==nativePreview.getAttribute('src'))preview.setAttribute('src',nativePreview.getAttribute('src'));
          }
          wrapper.querySelectorAll('.moonbundle-option-selector').forEach(selector=>{
            const label=selector.querySelector('.moonbundle-option-name');
            const selected=selector.querySelector('.moonbundle-swatch-buttons__button[aria-checked="true"]');
            if(label&&selected){const value=selected.dataset.value?.replace(/^Kunstleder\s+/,'')||'';const text=colorPrefix+' '+value;if(label.textContent!==text)label.textContent=text;}
          });
        });
      });
    }
    function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(update);}}
    const observer=new MutationObserver(schedule);
    observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['src','aria-checked']});
    root.addEventListener('click',schedule);
    root.addEventListener('keydown',schedule);
    root.addEventListener('change',schedule);
    update();
    root.addEventListener('wallet:bundle-design-disconnect',()=>observer.disconnect(),{once:true});
  });
}
initWalletBundleDesign();
document.addEventListener('shopify:section:load',event=>initWalletBundleDesign(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-wallet-offer]').forEach(root=>root.dispatchEvent(new Event('wallet:bundle-design-disconnect'))));
  } catch(e) { console.error(e); }
})();

})();
